/**
 * @fileoverview GET handler for the "/engagement/segments/tags" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

import { engagementSegmentsTags } from "./constants";
import type { EngagementSegmentsTagsParams, EngagementSegmentsTagsResult } from "./types";

export const getEngagementSegmentsTags = reactQueryFetcherAdapter(
  engagementSegmentsTags,
  (signal: AbortSignal, { appGroupId }: EngagementSegmentsTagsParams): Promise<EngagementSegmentsTagsResult> => {
    return fetch(
      "/engagement/segments/tags",
      "GET",
      {
        show_id: true,
        app_group_id: appGroupId,
      },
      { signal }
    );
  }
);
